export const graphqlBaseUrl = process.env.REACT_APP_BACKEND_URL;
export const algoBaseUrl = process.env.REACT_APP_ALGO_BACKEND_URL;
export const SOLANA_CLUSTER = process.env.REACT_APP_SOLANA_CLUSTER;